export const gestureThreshold = 5

export type GestureDirection = "horizontal" | "vertical"

export const getGestureDirection = (dx: number, dy: number): GestureDirection | null => {
    if (Math.max(Math.abs(dx), Math.abs(dy)) <= gestureThreshold) {
        return null
    }

    return Math.abs(dx) > Math.abs(dy) ? "horizontal" : "vertical"
}
